<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>个人事务管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/expense` }">报销管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/expense/view?id=${query.id}` }">报销详情</el-breadcrumb-item>
        <el-breadcrumb-item>报销支付</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="header">
      <div class="header-info">
        <h1>{{ form.description }}</h1>
        <p>{{ userArr.realname }} {{ userArr.en_name }}</p>
        <p>{{ userArr.department?.en_name }} - {{ userArr.role?.role_name}}</p>
        <p>直属领导：{{ userArr.leader_name }} {{ userArr.leader_en_name }} </p>
        <p>报销月份：{{ form.expense_date_month }}月</p>
      </div>
    </div>
    <!-- 报销明细 -->
    <div class="table">
      <h3 class="ntitle">报销明细</h3>
      <div>
        <el-table :data="itemList" stripe border scroll highlight-current-row>
          <el-table-column type="index" label="序号" header-align="center" align="center" min-width="80" />
          <el-table-column prop="service_type_name" label="服务类目" header-align="center" align="center" min-width="120" />
          <el-table-column prop="expense_amount" label="金额（元）" header-align="center" align="right" min-width="120" />
          <el-table-column prop="description" label="备注" header-align="center" align="left" min-width="200" />
          <el-table-column prop="brand" label="关联品牌" header-align="center" align="center" min-width="200">
            <template slot-scope="scope">
              {{ scope.row.brand ? scope.row.brand : '/' }}
            </template>
          </el-table-column>
          <el-table-column prop="contract_no_name" label="关联项目" header-align="center" align="center" min-width="200">
            <template slot-scope="scope">
              {{ scope.row.project_id != '0' ? `${scope.row.project?.contract_no}-${scope.row.project?.contract_name}` :
                '/' }}
            </template>
          </el-table-column>
          <el-table-column prop="file" label="附件" header-align="center" align="center" min-width="200">
            <template slot-scope="scope">
              {{ scope.row.atta_str[0].origin_name }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="expense">
        <div>当前填报总金额：{{ form.total_expense_amount }}</div>
        <div>业务金额：{{ form.total_business_amount }}</div>
        <div>日常金额：{{ form.total_daily_amount }}</div>
      </div>
    </div>

    <div class="form myform">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
        <div class="formtitle">更新支付</div>
        <ul>
          <li>
            <p>
              <label>报销说明：</label><a>{{ form.description }}月份报销</a>
            </p>
            <p>
              <label>报销月份：</label><a>{{ form.expense_date_month }}月</a>
            </p>
          </li>
          <li>
            <p>
              <label>报销金额：</label><a>{{ form.expense_amount }}</a>
            </p>
          </li>
        </ul>
        <el-form ref="form" :model="form" label-width="150px" label-position="left" class="ulform">
          <el-form-item label="付款时间：" prop="pay_time">
            <el-col :span="5">
              <i class="ico-reddot" style="left: -160px;">*</i>
              <el-date-picker v-model="form.pay_time" type="datetime" value-format="yyyy-MM-dd" style="width: 100%;">
              </el-date-picker>
            </el-col>
          </el-form-item>
          <template>
            <ul class="anlist">
              <li v-for="(_it, _id) in form.pay_str" :key="_id">
                <div class="abox">
                  <el-form-item :label='`付款凭证附件${_id + 1}：`'>
                    <el-col style="width: 90px;" v-if="(!_it.id && !_it.file_id) || level == 1">
                      <i class="ico-reddot" style="left: -160px;">*</i>
                      <el-upload class="upload-demo" :ref="`upFile${_id}`" action="#" :limit="1" :show-file-list="false"
                        :auto-upload="false" accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png" :file-list="_it.flist"
                        :on-change="(arg) => uploadFile(arg, form.pay_str, `upFile${_id}`, _it, _id)">
                        <el-button size="small" style="width: 100%">选择文件</el-button>
                      </el-upload>
                    </el-col>
                    <template v-if="_it.origin_name">
                      <div class="origin_name" style="width: 600px;">
                        <a style="max-width: 550px;">
                          <div class="origin-name">{{ _it.origin_name }}</div>
                        </a>
                        <a style="width: 50px;">
                          <el-link type="primary" style="margin-right:5px" :href="_it.httpImg" target="_blank">查看</el-link>
                        </a>
                      </div>
                    </template>
                  </el-form-item>
                </div>
                <el-button class="bbtn" v-if="_id === 0" icon="el-icon-plus" @click="addPay(form.pay_str)" circle></el-button>
                <el-button class="bbtn" v-if="_id > 0 && ((!_it.id && !_it.file_id) || level == 1)" icon="el-icon-minus" @click="removePay(form.pay_str, _id)" circle></el-button>
              </li>
            </ul>
          </template>
        </el-form>

        <el-form-item label="" v-if="NodeInclude('193')">
          <el-col>
            <el-button @click="resetForm('form')">取消</el-button>
            <el-button type="primary" @click="submitForm('form')">保存</el-button>
          </el-col>
        </el-form-item>

      </el-form>
    </div>
  </el-main>
</template>

<script>
import * as api from '@/api'
import { thousands, timeFormat } from '@/utils/index.js'
import store from '@/store'
export default {
  name: 'expensePay',
  data() {
    return {
      nodeLimtList: [],
      mType: '4',
      level: '',
      userArr: {
        en_name: '',
        realname: '',
      },
      userList: [],
      itemList: [],
      form: {

      },
      tempPayList: [
        { vendorArr: { type: '', } }
      ],//临时支付数组
      p: 1,
      type: 0,
      rules: {
        pay_time: [
          { required: true, message: '请输入付款时间', trigger: 'blur' },
        ],
      },
      del_pay_list: [],
    }
  },
  created() {
    this.query.id && this.getDetail(this.query.id)
    setTimeout(() => {
      //权限
      this.level = store.state.level
    }, 200);
  },
  mounted() {
    this.getServiceList()
    this.getUserList()
  },
  watch: {

  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    async getUserList() {
      this.$fly
        .post('apiAccount_getUserList.html', {
          per_page: 5000,
        })
        .then((res) => {
          this.userList = res.itemList
        })
    },
    async getServiceList() {
      this.$fly
        .post('ApiAdministrative_serviceTypeDropdownList.html', {
          per_page: 5000,
          id: '10'
        })
        .then((res) => {
          this.serviceList = res
        })
    },
    async getUserDetail(id) {
      this.$fly
        .post('ApiStaffReimbursement_getStaffInfo.html', {
          uid: id,
        })
        .then((res) => {
          this.userArr = res
        })
    },
    //选择文件
    uploadFile(file, fileList, ref, item, index) {
      let formData = new FormData();
      formData.append("file_arr", file.raw);
      formData.append("type", 5);
      formData.append("file_pay_type", 2);
      api.uploadFile(formData)
        .then((res) => {
          fileList[index] = {
            ...item,
            origin_name: res.origin_name,
            file_name: res.file_name,
            httpImg: res.httpFile,
          }
          this.$forceUpdate()
          this.$refs[ref][0].clearFiles();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addPay(arr) {
      console.log(arr);
      arr.push({ origin_name: '', file_name: '', httpImg: '', id: '', flist: [] });
      this.$forceUpdate()
    },
    removePay(arr, index) {
      this.del_pay_list.push(arr[index].id);
      console.log(this.del_pay_list);
      arr = arr.splice(index, 1);
      this.$forceUpdate()
    },
    getDetail(id) {
      this.checkUrlFn()
      this.checkNodeFn('61')
      const apiUrl = 'ApiStaffReimbursement_getStaffReimbursementDetail.html'
      this.$fly
        .post(apiUrl, {
          reimbursement_id: id,
        })
        .then((res) => {
          this.trackList = res.track_list
          let form = res
          this.isDraft = form.is_draft
          form.expense_date_str = this.dateForm(form.expense_date)[0]
          form.expense_date_year = this.dateForm(form.expense_date)[1]
          form.expense_date_month = this.dateForm(form.expense_date)[2]
          form.pay_time = timeFormat(form.pay_time)
          this.getUserDetail(form.user_id)
          const atta_str = () => [{ origin_name: '', file_name: '', httpImg: '', id: '', flist: [] }]
          form.pay_str = res.reimbursement_pay_file.length != 0 ? res.reimbursement_pay_file : atta_str()
          this.itemList = form.reimbursement_detail.map(({ id, service_type, service_type_name, expense_amount, description, brand, project_id, project, reimbursement_file, }) => {
            return {
              id,
              service_type,
              service_type_name,
              expense_amount,
              description,
              brand,
              project_id,
              project,
              // contract_no_name: project_id == '0' ? '关联项目' : project.contract_name,
              atta_str: [reimbursement_file,]
            }
          })
          console.log(this.itemList);
          this.form = form
          this.numberFn()
        })
    },
    //计算数字
    numberFn() {
      let expense = 0, daliy = 0, business = 0;
      for (let i = 0; i < this.itemList.length; i++) {
        const _item = this.itemList[i];
        if (_item.service_type == '73' || _item.service_type == '76' || _item.service_type == '77') {
          daliy += Number(_item.expense_amount)
        }
        else if (_item.service_type == '74' || _item.service_type == '75') {
          business += Number(_item.expense_amount)
        }
        expense += Number(_item.expense_amount)
      }
      this.form = {
        ...this.form,
        total_expense_amount: thousands(Number(expense)),
        total_business_amount: thousands(Number(business)),
        total_daily_amount: thousands(Number(daliy)),
      }
    },
    dateForm(str) {
      const strArr = str.split('-')
      return [`${strArr[0]}年${strArr[1]}月`, strArr[0], strArr[1]]
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUpdatePay()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addUpdatePay() {
      if (!this.form.pay_time) {
        this.$message.error('请选择付款时间')
        return false
      }
      // 替换掉id为file_id
      const $payList = this.form.pay_str.map((item) => {
        Object.keys(item).forEach(key => {
          if (key == 'id') {
            item['file_id'] = item[key] || 0
            console.log(item['file_id']);
            delete item[key]
          }
        })
        return item
      })
      this.$fly
        .post('ApiStaffReimbursement_updatePayStatus.html', {
          reimbursement_id: this.form.id,
          option: 2,
          pay_time: this.form.pay_time,
          pay_attr: JSON.stringify($payList),
          detail_del: this.del_pay_list.toString(),
        })
        .then((res) => {
          console.log(res)
          if (res.status === 200) {
            this.$message.success(res.message)
          }
          this.$router.go(-1)
        })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss" scoped>
.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;
    line-height: 42px;

    .anlist {
      padding: 0;
      flex-flow: column nowrap;

      li {
        width: 100%;
        position: relative;
        padding: 0;

        .abtn {
          position: absolute;
          top: 0;
          left: 65%;
        }

        .bbtn {
          position: absolute;
          top: 0;
          left: 800px;
        }
      }
    }

    ul {
      @extend %start;
      color: var(--text-1); /* 0819修改 */;
      // background: #f2f2f2;
      padding: 0;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 50%;
        font: 14px/42px $font;
        padding: 5px 0;
        p {
          min-height: 42px;
          // padding: 5px 0;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }


        }
      }
    }
  }

  .formtitle {
    position: relative;
    left: -50px;
    margin-bottom: 30px;
    font-size: 28px;
    line-height: 48px;
    font-weight: 600;
  }

  .base1 {
    @extend %box;
    margin-bottom: 20px;
    padding: 30px 40px;
    position: relative;

    ul {
      @extend %start;
      color: var(--text-1); /* 0819修改 */;
      background: var(--bg-soft); /* 0819修改 */
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 50%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }


        }
      }
    }
  }
}

.header {
  //标题样式
  @extend %box;
  box-sizing: border-box;
  width: 100%;
  background: var(--card); /* 0819修改 */
  padding: 20px 40px;
  margin-bottom: 10px;
  @extend %center;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-start;

  .header-info {
    width: 80%;
    @extend %center;
    align-items: flex-start;
    text-align: left;

    h1 {
      font: 700 28px/1 $font;
      margin-bottom: 16px;
    }

    p {
      font: 16px/2 $font;

      &.info-detail {
        color: #999;
        font: 12px/2 $font;
        white-space: pre-wrap;
      }

      &.pdou {
        span {
          &::after {
            content: ',';
            display: inline-block;
          }

          &:last-of-type {
            &::after {
              display: none;
            }
          }
        }
      }
    }
  }

  .header-status {
    @extend %center;
    flex-flow: row nowrap;

    .button {
      box-sizing: border-box;
      min-width: 100px;
      border-radius: 20px;
      padding: 10px 15px;
      font: 12px/1 $font;
      color: #fff;
    }
  }
}

.table {
  position: relative;
  margin-bottom: 20px;

  .expense {
    @extend %start;
    padding: 30px 0;

    >div {
      margin-right: 30px;
    }
  }
}

.aul.ulist {
  padding: 20px 0;
  font: 14px/2 $font;
  text-align: left;

  >li {
    padding: 0 60px;
    display: flex;
    flex-flow: row nowrap;

    span {
      display: inline-block;
      &:first-of-type {
        width: 50%;
      }
      &:last-of-type {
        width: 50%;
      }
    }
  }

  .ulform {
    padding: 0 60px;
  }

  .el-form-item--small.el-form-item {
    margin-bottom: 0;
  }
}

.origin_name {
  @extend %start;
  >a {
    text-align: center;
  }
}
</style>